import Rest from '../Rest'

export default class RequestCategoryFormService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/request_category'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
